import { useTranslation } from "react-i18next";
import { stats } from "@/mocks/highlights";

export default function StatsSection() {
  const { t } = useTranslation();

  const labelKeys: Record<string, string> = {
    "香港註冊成立": "stats.established",
    "免稅資格認可": "stats.taxExempt",
    "國際品牌合作": "stats.brandPartners",
    "國家與地區覆蓋": "stats.countries",
  };

  return (
    <section className="relative w-full py-16 md:py-20 bg-primary-800 text-background-50 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20elegant%20cream%20and%20burgundy%20geometric%20pattern%20with%20subtle%20golden%20lines%2C%20refined%20editorial%20texture%20background%2C%20soft%20warm%20tones%2C%20minimalist%20academic%20design%2C%20light%20decorative%20composition%20with%20artistic%20flow&width=1800&height=600&seq=iabs-stats-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {stats.map((s) => (
            <div key={s.label} className="text-center border-r border-background-50/15 last:border-r-0 md:pr-6 last:pr-0">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-full bg-accent-500/20 mb-4">
                <i className={`${s.icon} text-2xl md:text-3xl text-accent-300 w-8 h-8 flex items-center justify-center`}></i>
              </div>
              <div className="font-heading font-bold text-3xl md:text-5xl text-background-50 mb-2">{s.value}</div>
              <div className="text-xs md:text-sm text-background-100/80 tracking-widest">{t(labelKeys[s.label] || s.label)}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}